import ContinueWatching from './ContinueWatching'

export default ContinueWatching
